export enum PaymentType {
    CASH = "C",
    OTHER = "O",
    CREDIT_CARD = "R",
    PIX = "P"
}